import React, { Component } from 'react';
import {connect} from 'react-redux'
import flow from 'lodash/flow'
import cn from 'classnames'
import {withStyles} from 'material-ui/styles'
import logo from '../img/logo.svg'
import Button from 'material-ui/Button'
import {login, forgetPassword, register} from '../actions'

class Login extends Component {

    render() {
        const {classes, handleLogin, handleForgotPassword} = this.props;
        return (
            <div className={classes.root}>
                <div className={cn(classes.container, classes.registration)}>
                    <div className={classes.logo}>
                        <img src={logo} alt="Evoenergy logo" />
                    </div>
                    <div className={classes.content}>
                        <h1>Welcome</h1>
                        <h2>Need an account, contact your administrator and they can add you to the system</h2>

                        <div className={cn('flow', classes.loginMobile)}>
                            <p className={classes.bodyCopy}>
                                Or if you already have an account
                            </p>
                            <div className={classes.loginActions}>
                                <Button onClick={handleLogin} color="accent" raised className={classes.button}>Login</Button>
                                <a onClick={handleForgotPassword}>Forgot password?</a>
                            </div>
                        </div>

                    </div>
                    <div className={classes.footer}>
                        <ul className={classes.links}>
                            <li><a href="./faq">FAQ</a></li>
                            <li><a href="./privacypolicy">Privacy Policy</a></li>
                            <li><a href="./terms">Terms and Conditions</a></li>
                            <li><a>{process.env.REACT_APP_BUILD_NUMBER}</a></li>
                            
                        </ul>

                    </div>
                </div>
                <div className={cn(classes.container, classes.login)}>
                    <h3>Or if you already have an account</h3>
                    <div className={classes.loginActions}>
                        <Button onClick={handleLogin} raised color="primary">Login</Button>
                        <a onClick={handleForgotPassword}>Forgot password?</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        handleLogin: () => {
            dispatch( login() );
        },
        handleRegister: (type) => {
            dispatch(register(type))
        },
        handleEmployeeRegister: () => {
            dispatch(register('employee'))

        },
        handleForgotPassword: () => {
            dispatch(forgetPassword())
        }
    }
}

const padding = (theme) => ({
    padding: theme.spacing.unit * 2,
    minHeight: `calc(100vh - ${theme.spacing.unit * 2 * 2}px)`,
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing.unit * 5,
            minHeight: `calc(100vh - ${theme.spacing.unit * 5 * 2}px)`,
    },
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing.unit * 10,
        minHeight: `calc(100vh - ${theme.spacing.unit * 10 * 2}px)`,
    }
})

const styles = theme => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        "& a": {
            textDecoration: 'none',
            color: 'white',
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
                color: 'white',
            }
        }
    },
    container: {
        ...padding(theme),
        color: 'white',
    },
    registration: {
        flex: '65%',
        backgroundColor: theme.palette.primary['500'],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            alignItems: 'stretch',
        }
    },
    logo: {
        maxWidth: 300,
        width: '100%',
        marginTop: theme.spacing.normal,
        [theme.breakpoints.up('sm')]: {
            marginTop: 0,
        },
    },
    content: {
        width: '100%',
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
            width: 'auto',
            textAlign: 'inherit',
        },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        '& h1': {
            margin: 0,
            fontSize: '3rem',
            [theme.breakpoints.up('md')]: {
                fontSize: '4rem',
            },
            fontWeight: '300',
        },
        '& h2': {
            margin: `0 0 ${theme.spacing.normal}px`,
            fontSize: '1.2rem',
            [theme.breakpoints.up('md')]: {
                fontSize: '1.5rem',
            },
            fontWeight: '300',
            color: '#ccc'
        }
    },
    hideOnMobile: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'block'
        }
    },
    bodyCopy: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 800,
        },
        '& strong': {
            fontSize: '1rem',
            fontWeight: 500
        }
    },
    footer: {
    },
    links: {
        fontSize: '0.8rem',
        display: 'flex',
        margin: `0 -${theme.spacing.small}px`,
        textAlign: 'center',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'left',
        },
        '& li': {
            listStyle: 'none',
            margin: `0 ${theme.spacing.small}px`
        },
    },
    loginMobile: {
        display: 'block',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    login: {
        display: 'none',
        maxWidth: 350,
        minWidth: 320,
        flex: '100%',
        //backgroundColor: theme.palette.secondary['A200'],
        backgroundColor: theme.palette.secondary['700'],
        transition: 'all 1s ease',
        padding: theme.spacing.unit * 5,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',

        [theme.breakpoints.up('md')]: {
            display: 'flex',
            padding: theme.spacing.unit * 10,
        },
        '&:hover': {
            maxWidth: 370,
        },
        '& h3': {
            fontWeight: '300',
        }
    },
    loginActions: {
        '& a': {
            marginLeft: theme.spacing.xsmall
        }
    },
    loginForm: {
        width: '100%'
    },
    formControl: {
        width: '100%',
        color: 'white',
        marginBottom: theme.spacing.normal,
    },
    inputLabel: {
        color: 'rgba(255,255,255,0.75)',
    },
    inputLabelFocused: {
        color: 'rgba(255,255,255,0.75)',
    },
    input: {
        color: 'white',
        fontSize: '1.5rem'
    },
    inputInkbar: {
        '&:before, &:hover:before': {
            backgroundColor: 'white !important'
        },
        '&:after': {
            backgroundColor: 'white !important'
        }
    },
    button: {
        color: 'white',
        backgroundColor: theme.palette.secondary['500'],
        margin: `0 ${theme.spacing.xsmall}`
    }
});

export default flow([
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
])(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js